/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import app from 'flarum/forum/app';
import AchievementCategoryName from '../../../common/components/AchievementCategoryName';
export default class AchievementHero extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }
  view() {
    const {
      achievement,
      loading
    } = this.attrs;
    if (!achievement || loading) {
      return null;
    }
    const category = achievement.category();
    return m("div", {
      className: "Hero"
    }, m("div", {
      className: "AchievementHero"
    }, !loading && achievement && [m("h1", {
      className: "Hero-title"
    }, achievement.name()), m("div", {
      className: "Hero-subtitle"
    }, m(Link, {
      href: app.route('achievements', {
        category: category.id()
      })
    }, m(AchievementCategoryName, {
      category: category
    })), achievement.description())]));
  }
}
flarum.reg.add('glowingblue-gamilytics', 'forum/achievements/components/AchievementHero', AchievementHero);